<script>
import moment from 'moment';
moment.locale('pt-BR');

import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import CouponService from '@/services/coupon'
import CompanyService from '@/services/company'
import { VMoney } from 'v-money'
import DatePicker from "vue2-datepicker";
import 'vue2-datepicker/locale/pt-br';

export default {
  page: {
    title: "Cupons de Desconto",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, DatePicker },
  directives: { money: VMoney },
  data() {
    return {
      title: "Cupons de Desconto",
      coupons: [],
      shippingOptions: [],
      fields: [
        { key: 'code', sortable: true, label: 'Código' },
        { key: 'type', sortable: true, label: 'Tipo de Desconto', formatter: (value) => {
          return value === 'value' ? 'por Valor' : 'por Percentual';
        } },
        { key: 'value', sortable: true, label: 'Valor', formatter: (value, index, item) => {
          if (item.discount_type === 'value') {
            return (value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
          }

          if (item.discount_type === 'percentage') {
            return `${(value || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}%`
          }

         return '-'
        } },
        { key: 'date', sortable: true, label: 'Período', formatter: (value, index, item) => {
          return `${moment(item.start_date).format('DD/MM/YYYY')} até ${moment(item.end_date).format('DD/MM/YYYY')}`;
        } },
        { key: 'status', sortable: true, label: 'Status' },
        { key: 'minimum_sale_value', sortable: true, label: 'Pedido Mínimo', formatter: (value) => {
          return (value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        } },
        { key: 'actions', label: 'Ações' },
      ],
      modalError: '',
      coupon: {
        code: '',
        discount_type: 'value',
      },
      searchValue: '',
      count: 0,
      currentCount: 0,
      currentPage: 1,
      totalPages: 0,
      perPage: 20,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false,
      },
    };
  },
  computed: {
    rows() {
      return this.coupons.length;
    },
    startIndex() {
      return (this.currentPage * this.perPage) - this.perPage + 1;
    },
    endIndex() {
      const endIndex = (this.currentPage * this.perPage);
      if (this.coupons.length < endIndex) {
        return this.coupons.length;
      }

      return endIndex;
    }
  },
  mounted() {
    this.load();

    CompanyService.getShippingOptions().then(res => {
        this.shippingOptions = res.data;
      });
  },
  methods: {
    load(loader = null) {
      if (!loader) {
        loader = this.$loading.show();
      }

      CouponService.getCoupons().then(res => {
        this.coupons = res.data;

        loader.hide();
      }, () => {
        loader.hide();
      })
    },
    newCoupon() {
      this.coupon = {
        code: '',
        shipping_option: ''
      }
      this.modalError = '';

      this.$bvModal.show('modal-edit');
    },
    editCoupon(item) {
      // eslint-disable-next-line no-console
      console.log(item);

      this.coupon = {
        _id: item._id,
        code: item.code,
        discount_type: item.discount_type,
        value: item.value.toFixed(2).replace('.', ','),
        minimum_sale_value: (item.minimum_sale_value || 0).toFixed(2).replace('.', ','),
        start_date: new Date(item.start_date),
        end_date: new Date(item.end_date),
        auto_apply: item.auto_apply,
        only_users_without_sale: item.only_users_without_sale,
        only_in_shipping_value: item.only_in_shipping_value,
        allow_repeat_use_same_customer: item.allow_repeat_use_same_customer,
        shipping_option: item.shipping_option || '',
        // usage_limit: item.usage_limit,
        // value_limit: item.value_limit.toFixed(2).replace('.', ','),
      }
      this.modalError = '';

      this.$bvModal.show('modal-edit');
    },
    async saveCoupon() {
      this.modalError = '';
      if (!this.coupon.code) {
        return this.modalError = 'Informe o código do cupom';
      }

      let loader = this.$loading.show();

      try {
        if (this.coupon._id) {
          await CouponService.updateCoupon(this.coupon);
        } else {
          await CouponService.createCoupon(this.coupon);
        }

        this.$bvModal.hide('modal-edit');
        this.$toast.open('Dados atualizados com sucesso');

        this.load(loader);
      } catch (err) {
        loader.hide();

        const errorData = err.response.data;
        if (errorData.code) {
          if (errorData.code === 'E9999') {
            return this.modalError = errorData.msg;
          }
        }

        this.modalError = 'Ocorreu um erro ao salvar o cupom';
      }

    },
    async remove() {
      this.$bvModal.hide('modal-remove');

      let loader = this.$loading.show();

      try {
        await CouponService.removeCoupon(this.coupon);

        this.$toast.open('Registro removido com sucesso');

        this.load(loader);
      } catch (err) {
        loader.hide();

        const errorData = err.response.data;
        if (errorData.code) {
          if (errorData.code === 'E9999') {
            return this.$toast.warning(errorData.msg);
          }
        }

        this.$toast.error('Ocorreu um erro ao excluir o cupom. Tente novamente.');
      }
      
    },
    removeCoupon(item) {
      this.coupon = {
        _id: item._id,
        code: item.code,
      }

      this.$bvModal.show('modal-remove');
    },
    activateCoupon(id) {
      let loader = this.$loading.show();

      CouponService.activateCoupon(id).then(() => {
        this.load(loader);
        this.$toast.open('Cupom ativado com sucesso');
      }).catch((err) => {
        loader.hide();

        const errorData = err.response.data;
        if (errorData.code) {
          if (errorData.code === 'E9999') {
            return this.$toast.warning(errorData.msg);
          }
        }

        this.$toast.error('Ocorreu um erro ao ativar o cupom. Tente novamente.');
      })
    },
    deactivateCoupon(id) {
      let loader = this.$loading.show();

      CouponService.deactivateCoupon(id).then(() => {
        this.load(loader);
        this.$toast.open('Cupom desativado com sucesso');
      }).catch(() => {
        loader.hide();
        this.$toast.error('Ocorreu um erro ao desativar o cupom. Tente novamente.');
      })
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div class="page-title-box d-flex align-items-center justify-content-between">
          <h4 class="mb-0 font-size-18">{{title}}</h4>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body"> 
            <div class="row mb-2">
              <div class="col-sm-12">
                <div class="text-sm-right">
                  <button type="button" class="btn btn-primary btn-rounded mb-2 mr-2" @click="newCoupon">
                    <i class="mdi mdi-plus mr-1"></i> Novo Cupom
                  </button>
                </div>
              </div>
            </div>

            <div class="table-responsive mb-0">
              <b-table
                show-empty
                emptyText="Nenhum registro para exibir"
                :items="coupons"
                :fields="fields"
                responsive="sm"
                head-variant="light"
                :per-page="perPage"
                :current-page="currentPage"
              >
                <template v-slot:cell(status)="row">
                  <span
                    class="badge badge-pill badge-soft-success font-size-12"
                    :class=" {
                      'badge-soft-danger': !row.item.active,
                      'badge-soft-warning': row.item.status === 'awaitingPayment',
                    }"
                  >{{row.item.active ? 'Ativo' : 'Inativo'}}</span>
                </template>   

                <template v-slot:cell(actions)="row">
                  <b-dropdown class="card-drop" variant="white" dropleft toggle-class="p-0">
                    <template v-slot:button-content>
                      <i class="mdi mdi-dots-horizontal font-size-18"></i>
                    </template>

                    <b-dropdown-item href="javascript: void(0);" v-if="row.item.active" @click="deactivateCoupon(row.item._id)">
                      <i class="fas fa-minus-circle text-danger mr-2 mt-2"></i>
                      Inativar
                    </b-dropdown-item>
                    <b-dropdown-item v-if="!row.item.active" @click="activateCoupon(row.item._id)">
                      <i class="fas fa-play-circle text-success mr-2 mt-2"></i>
                      Ativar
                    </b-dropdown-item>
                    <b-dropdown-item href="javascript: void(0);" @click="editCoupon(row.item)">
                      <i class="fas fa-edit text-warning mr-2 mt-2"></i>
                      Editar
                    </b-dropdown-item>
                    <b-dropdown-item v-b-modal.modal-remove @click="removeCoupon(row.item)">
                      <i class="fas fa-trash-alt text-danger mr-2 mt-2"></i>
                      Excluir
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </div>
          </div>
        </div>

        <div class="row justify-content-md-between align-items-md-center mt-4">
          <div class="col-xl-7">Mostrando {{startIndex}} - {{endIndex}} de {{rows}}</div>

          <div class="col-xl-5">
            <div class="text-md-right float-xl-right mt-2 pagination-rounded">
              <b-pagination
                v-model="currentPage" 
                :total-rows="rows"
                :per-page="perPage"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-edit" :title="coupon._id ? 'Alterando Cupom' : 'Novo Cupom'" centered>
      <b-alert v-if="modalError" v-model="modalError" variant="danger" class="mt-3" dismissible>{{modalError}}</b-alert>

      <div class="row">
        <div class="col-7">
          <div class="form-group">
            <label for="code">Código do Cupom</label>
            <input id="code" name="code" type="text" class="form-control" v-model="coupon.code" style="text-transform: uppercase" />
          </div>
        </div>

        <div class="col-5">
          <div class="form-group">
            <label for="code">Forma de Entrega</label>
            <select class="form-control" v-model="coupon.shipping_option">
              <option value="">TODAS</option>
              <option v-for="option in shippingOptions" :key="option._id" :value="option._id">{{option.description}}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-5">
          <div class="form-group">
            <label for="code">Tipo de Desconto</label>
            <select class="form-control" v-model="coupon.discount_type">
              <option value="value">por Valor</option>
              <option value="percentage">por Percentual</option>
              <!-- <option value="free_Frete shipping">Grátis</option> -->
            </select>
          </div>
        </div>

        <div class="col-3">
          <div class="form-group">
            <label for="price">Desconto</label>
            <div class="input-group">
              <!-- <div class="input-group-prepend">
                <span v-if="coupon.discount_type === 'value' || coupon.discount_type === 'free_shipping'" id="validationTooltipUsernamePrepend" class="input-group-text">R$</span>
                <span v-if="coupon.discount_type === 'percentage'" id="validationTooltipUsernamePrepend" class="input-group-text">%</span>
              </div> -->
              
              <input
                id="value"
                name="value"
                type="tel"
                class="form-control"
                v-model="coupon.value"
                v-money="money"
                :disabled="coupon.discount_type === 'free_shipping'"
              />
            </div>
          </div>
        </div>

        <div class="col-4">
          <div class="form-group">
            <label for="price">Pedido Mínimo (R$)</label>
            <input
              id="minimum_sale_value"
              name="minimum_sale_value"
              type="tel"
              class="form-control"
              v-model="coupon.minimum_sale_value"
              v-money="money"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <div class="form-group mb-3">
            <label>Data de Início</label>
            <br />
            <date-picker v-model="coupon.start_date" :first-day-of-week="1" lang="pt-br" format="DD/MM/YYYY"></date-picker>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group mb-3">
            <label>Data Final</label>
            <br />
            <date-picker v-model="coupon.end_date" :first-day-of-week="1" lang="pt-br" format="DD/MM/YYYY"></date-picker>
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-sm-12">
          <div class="custom-control custom-checkbox mb-2">
            <input type="checkbox" class="custom-control-input" id="auto_apply" v-model="coupon.auto_apply" />
            <label class="custom-control-label" for="auto_apply">Aplicar automaticamente no checkout</label>
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-sm-12">
          <div class="custom-control custom-checkbox mb-2">
            <input type="checkbox" class="custom-control-input" id="only_users_without_sale" v-model="coupon.only_users_without_sale" />
            <label class="custom-control-label" for="only_users_without_sale">Válido apenas para primeira compra do cliente</label>
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-sm-12">
          <div class="custom-control custom-checkbox mb-2">
            <input type="checkbox" class="custom-control-input" id="only_in_shipping_value" v-model="coupon.only_in_shipping_value" />
            <label class="custom-control-label" for="only_in_shipping_value">Aplicar desconto apenas na taxa de entrega</label>
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-sm-12">
          <div class="custom-control custom-checkbox mb-2">
            <input type="checkbox" class="custom-control-input" id="allow_repeat_use_same_customer" v-model="coupon.allow_repeat_use_same_customer" />
            <label class="custom-control-label" for="allow_repeat_use_same_customer">Permitir usar novamente no mesmo cliente</label>
          </div>
        </div>
      </div>
      
      <template v-slot:modal-footer>
        <b-button variant="link" @click="$bvModal.hide('modal-edit')">Cancelar</b-button>
        <b-button variant="primary" @click="saveCoupon()">
          Salvar
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-remove"
      title="Excluir Registro?"
      title-class="font-18"
      centered
    >
      <p>Confirma a exclusão do cupom <b>{{coupon.code}}</b>?</p>

      <div slot="modal-footer">
        <b-btn variant="link" @click="$bvModal.hide('modal-remove')">Cancelar</b-btn>
        <b-btn variant="primary" @click="remove">Excluir</b-btn>
      </div>
    </b-modal>
  </Layout>
</template>
